export const EMPLOYEE_PAY_SLIP_DETAILS = "employee_pay_slip_details";
export const EMPLOYEE_PAY_SLIP_DETAILS_SUCCESS =
  "employee_pay_slip_details_success";
export const EMPLOYEE_PAY_SLIP_DETAILS_FAILURE =
  "employee_pay_slip_details_failure";
